import * as t from "io-ts";

export enum BoostCode {
    FiveHundredRows = "boost-rows-500",
    OneKiloRows = "boost-rows-1000",
    TwoKiloFiveRows = "boost-rows-2500",
    FiveKiloRows = "boost-rows-5000",
    OneKiloReads = "boost-reads-1000",
}

// FIXME: Is this the best way to do this?
export const boostCodeCodec = t.union([
    t.literal(BoostCode.FiveHundredRows),
    t.literal(BoostCode.OneKiloRows),
    t.literal(BoostCode.TwoKiloFiveRows),
    t.literal(BoostCode.FiveKiloRows),
    t.literal(BoostCode.OneKiloReads),
]);
